(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["memorial-day-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.mas-md-bar').forEach(function (bar) {
    var endIso = bar.getAttribute('data-end');
    if (!endIso) return;
    var endMs = Date.parse(endIso);
    if (isNaN(endMs)) return;

    var allowDismiss = bar.getAttribute('data-allow-dismiss') === 'true';
    var showCountdown = bar.getAttribute('data-show-countdown') === 'true';
    var storageKey = 'mas-md-bar-dismissed:' + bar.id;

    // Hide if dismissed this browser session
    if (allowDismiss) {
      try {
        if (sessionStorage.getItem(storageKey) === '1') {
          bar.setAttribute('hidden', '');
          return;
        }
      } catch (e) { /* sessionStorage blocked — fall through */ }
    }

    // Hide if past end date
    if (Date.now() > endMs) {
      bar.setAttribute('hidden', '');
      return;
    }

    // Dismiss handler
    var dismissBtn = bar.querySelector('[data-dismiss]');
    if (dismissBtn) {
      dismissBtn.addEventListener('click', function () {
        bar.setAttribute('hidden', '');
        try { sessionStorage.setItem(storageKey, '1'); } catch (e) { /* ignore */ }
      });
    }

    // Live countdown
    if (showCountdown) {
      var daysEl = bar.querySelector('[data-days]');
      var hoursEl = bar.querySelector('[data-hours]');
      var minsEl = bar.querySelector('[data-mins]');

      function pad(n) { return n < 10 ? '0' + n : String(n); }

      function tick() {
        var diff = endMs - Date.now();
        if (diff <= 0) {
          bar.setAttribute('hidden', '');
          clearInterval(timer);
          return;
        }
        var totalSec = Math.floor(diff / 1000);
        var days = Math.floor(totalSec / 86400);
        var hours = Math.floor((totalSec % 86400) / 3600);
        var mins = Math.floor((totalSec % 3600) / 60);
        if (daysEl) daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minsEl) minsEl.textContent = pad(mins);
      }
      tick();
      var timer = setInterval(tick, 30000); // minute-granularity, low CPU
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
